import { buildFieldsPreview } from "./schemaConstants"

export default function SchemaPreview({ fields }) {
    const preview = buildFieldsPreview(fields)

    return (
        <div className="mt-4 border border-gray-200 rounded-xl overflow-hidden">
            <div className="bg-gray-50 px-4 py-2 border-b border-gray-200">
                <span className="text-sm font-medium text-gray-600">
                    JSON Preview
                </span>
            </div>
            <pre className="p-4 text-sm bg-gray-900 text-green-400 overflow-x-auto">
                {JSON.stringify(preview, null, 2)}
            </pre>
        </div>
    )
}
